// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class GroupResource extends Resource {
    basePath: string = 'authorisation/groups/';

    objectPath: string = 'authorisation/groups/{ident}/';
}
